<template>
  <div :key="influencerStatus">
    <!-- TODO: Refactor -->
    <b-row class="d-flex justify-content-between align-items-center">
      <h5 v-if="influencerStatus === 'approved'" class="ml-auto mr-auto text-success mt-1">{{ $t('campaigns.statusApproved') }}</h5>
      <h5 v-if="influencerStatus === 'rejected'" class="ml-auto mr-auto text-danger mt-1">{{ $t('campaigns.statusRejected') }}</h5>
      <h5 v-if="influencerStatus === 'onboarding'" class="ml-auto mr-auto text-primary mt-1">{{ $t('campaigns.onboarding') }}</h5>
      <h5 v-if="influencerStatus === 'trading'" class="ml-auto mr-auto text-warning mt-1">{{ $t('campaigns.tradingProfiles') }}</h5>
      <h5 v-if="influencerStatus === 'producing'" class="ml-auto mr-auto text-warning mt-1">{{ $t('campaigns.producing') }}</h5>
      <h5 v-if="influencerStatus === 'submitted'" class="ml-auto mr-auto text-primary mt-1">{{ $t('campaigns.submitted') }}</h5>
      <h5 v-if="influencerStatus === 'published'" class="ml-auto mr-auto text-success mt-1">{{ $t('campaigns.published') }}</h5>
    </b-row>
    <div v-if="influencerStatus === 'pending'" :id="influencerUuid">
      <b-row class="d-flex justify-content-between align-items-center">
        <b-col><b-button class="blue-button mb-1" variant="blue-button" :disabled="disabledUpdateCampaign()"  @click="approvedButton(influencerUuid)">{{ $t('campaigns.approveBtn') }}</b-button></b-col>
        <b-col><b-button class="red-button mb-1"  variant="red-button" :disabled="disabledUpdateCampaign()"  @click="rejectedButton(influencerUuid)">{{ $t('campaigns.rejectBtn') }}</b-button></b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  VBToggle, BButton, BRow, BCol
} from 'bootstrap-vue'
import service from "@/services/campaign";
import { hasPermission } from '@/libs/utils/user';

export default {
  props: ['influencerStatus', 'influencerUuid'],
  components: {
    BButton,
    BRow,
    BCol,
  },
  directives: {
    'b-toggle': VBToggle
  },
  data () {
    return {
      hasPermission,
    }
  },
  methods: {
    approvedButton (id) {
      if (this.disabledUpdateCampaign()) return;
      service.influencerAction(this.$route.params.uuid, [id], 'approved')
        .then((response) => {
          this.statusApproved('success')

          this.$emit('update_influencer', response.results[0])
          this.$emit('updated_campaign')
        })
        .catch(() => {
          this.errorMessage()
        })
    },
    rejectedButton (id) {
      if (this.disabledUpdateCampaign()) return;
      service.influencerAction(this.$route.params.uuid, [id], 'rejected')
        .then((response) => {
          
          this.$swal({
            title: this.$t('campaigns.influencerRejected'),
            text: this.$t('campaigns.textInfluencerRejected'),
            iconHtml: `<img src="${require(`@/assets/images/icons/rejected.png`)}" width="25"/>`,
            customClass: {
              icon: 'text-danger-influencer',
              confirmButton: 'btn btn-outline-danger',
            },
            confirmButtonText: this.$t('campaigns.continue'),
            heightAuto: false,
            buttonsStyling: false
          })
          this.$emit('update_influencer', response.results[0])

        })
        .catch(() => {
          this.errorMessage()
        })
    },
    statusApproved (message_class) {
      let icon_text = message_class
      if (message_class === 'danger') icon_text = 'warning'

      this.$swal({
        title: this.$t('campaigns.influencerUpdate'),
        text: this.$t('campaigns.statusInfluencer'),
        icon: message_class,
        customClass: {
          confirmButton: `btn btn-${icon_text}`
        },
        heightAuto: false,
        buttonsStyling: false
      })
    },
    errorMessage () {
      this.$swal({
        title: this.$t('campaigns.errormessage'),
        text: this.$t('campaigns.tryAgainLater'),
        icon: 'danger',
        customClass: {
          confirmButton: 'btn btn-danger'
        },
        heightAuto: false,
        buttonsStyling: false
      })
    },
    disabledUpdateCampaign() {
      return !hasPermission('change_campaign')
    },
  },
}
</script>
<style>
.text-danger-influencer {
  color: #ea5455 !important;
  border-color: #ea5455 !important;
}
</style>
